import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {ErrorResponse} from "../services/apis/dtos/error-response";
import {AppRoutes} from "../routes/app-routes";
import {AuthStorageService} from "../services/utils/auth-storage/auth-storage.service";
import {Router} from "@angular/router";
import {NzNotificationService} from "ng-zorro-antd/notification";
import {NzMessageService} from "ng-zorro-antd/message";


@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {

  constructor(private readonly authStorageService: AuthStorageService,
              private readonly router: Router,
              private readonly notificationService: NzNotificationService,
              private readonly msg: NzMessageService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.authStorageService.clearAll();
          this.showNotification('احراز هویت', 'توکن شما منقضی شده یا به این بخش دسترسی ندارید.');
          this.router.navigate([AppRoutes.AUTH.LOGIN]);
        }

        const errorMessages: string[] = [];


        if (error.error?.data?.errors) {
          for (const key in error.error.data.errors) {
            if (error.error.data.errors.hasOwnProperty(key)) {
              errorMessages.push(...error.error.data.errors[key]);
            }
          }
        }

        if (errorMessages.length == 0 && error.error?.data?.message) {
          errorMessages.push(error.error.data.message);
        }

        const errorResponse: ErrorResponse = {
          status: 'error',
          data: {
            message: errorMessages,
          }
        };

        errorMessages.forEach(message => {
          this.msg.error(message);
        });

        return throwError(() => errorResponse);

      })
    );
  }

  private showNotification(title: string, content: string): void {
    this.notificationService.blank(title, content, {nzDuration: 3000});
  }
}
